import React from 'react'

export default ({ title }) => (
  <section className="hero text-center position-relative">
    <div className="container h-100 position-relative">
      <h1 className="page-title supertitle text-secondary w-100">
        {title}
      </h1>
    </div>
  </section>
)
